import React from 'react';

export const ModalContext = React.createContext({
  component: null,
  props: {},
  showModal: () => {},
  hideModal: () => {},
});

export const ModalRoot = () => (
  <ModalContext.Consumer>
    {({ component: Component, props, hideModal }) =>
      Component ? <Component {...props} onRequestClose={hideModal} /> : null
    }
  </ModalContext.Consumer>
);

// TODO: convert into a functional component
export class ModalProvider extends React.Component {
  // eslint-disable-next-line react/sort-comp
  showModal = (component, props = {}) => void this.setState({ component, props });
  hideModal = () => this.setState({ component: null, props: {} });

  state = {
    component: null,
    props: {},
    showModal: this.showModal,
    hideModal: this.hideModal,
  };

  render() {
    return <ModalContext.Provider value={this.state}>{this.props.children}</ModalContext.Provider>;
  }
}
